module.exports = __webpack_public_path__ + "img/arrow_mob.207b9604.svg";